<div class="documents">
  <h1>Select file</h1>
  <ri-filemanager [selectOnly]="true" (externalSelect)="fileSelected($event)" [mode]="'1'" style="display: block;">Loading...</ri-filemanager>
</div>
